import React from "react";
import styles from "./slider.module.css";

export default function Slider({
  min = 0,
  max = 1,
  value = 0,
  step = 0.01,
  onChange,
  className,
}) {
  return (
    <div className={`${className} ${styles.container}`}>
      <input
        className={styles.slider}
        type="range"
        min={min}
        step={step}
        max={max}
        value={value}
        onChange={onChange}
      />
    </div>
  );
}
